import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as utils from "../../Utils/comman";
import MultiFileUpload from "./MultiFileUpload";
import { useSelector } from "react-redux";
import {
  Document,
  DocumentCode,
  DocumentLike,
  DocumentText,
  DocumentText1,
  Image,
} from "iconsax-react";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import QueryModal from "./QueryModal";
import QueryList from "./QueryList";
import QuotationFile from "./QuotationFile";

function View(props) {
  const [formData, setFormData] = useState({
    meeting_date: null,
    meetingName: "",
    subject: "",
    counter: "",
    counterName: "",
    city: "",
    budget: "",
    notes: "",
  });
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [meeting, setMeeting] = useState([]);
  const [counter, setCounter] = useState([]);
  const [isDisable, setisDisable] = useState(false);
  const [showQueryModal, setShowQueryModal] = useState(false);
  const [fileUpload, setFileUpload] = useState("");

  const userProfile = useSelector((state) => state.userProfile.userProfile);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions,
  );
  const location = useLocation();
  const [queryListRefreshTrigger, setQueryListRefreshTrigger] = useState(0);
  const [currentUserId, setCurrentUserId] = useState("");
  const navigate = useNavigate();
  const [currentStatus, setCurrentStatus] = useState("1");
  const [brandAmt, setBrandAmt] = useState("");
  const [brandNote, setBrandNote] = useState("");
  const [notReceiveNots, setNotReceiveNotes] = useState("");
  const [error, setError] = useState("");
  const [fileUploads, setFileUploads] = useState({
    meetingPhotos: [],
    artisanData: [],
    meetingExpenses: [],
    expenseBills: [],
  });
  const [EditfileUploads, setEditFileUploads] = useState({
    meetingPhotos: [],
    artisanData: [],
    meetingExpenses: [],
    expenseBills: [],
  });
  const [finalAttach, setFinalAttach] = useState("");
  const [finalAmount, setFinalAmount] = useState("");
  const [finalNote, setFinalNote] = useState("");
  const [finalConfirmNote, setFinalConfirmNote] = useState("");
  const [currentAction, setCurrentAction] = useState("Add");
  const [editQuotation, setEditQuotation] = useState([]);
  const [quotation, setQuotation] = useState([]);
  const [isquotation, setisquotation] = useState(true);

  const queryParams = new URLSearchParams(location.search);
  queryParams.delete("id");

  const handleBackClick = () => {
    queryParams.delete("id");

    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
    // navigate(`${location.pathname}?${queryParams.toString()}`);
  };

  useEffect(() => {
    getMeeting();
    getCounter();
  }, []);

  const getMeeting = () => {
    utils
      .callAPI("get", `/meeting/subject/list?page=${0}&per_page=${0} `)
      .then((res) => {
        if (typeof res !== "undefined") {
          // setMeeting(res);
          const activeSub = res.result.filter((m) => m.isActive === "1");
          setMeeting(activeSub);
        } else {
          setMeeting([]);
        }
      })
      .catch((err) => {
        setMeeting([]);
      });
  };

  const vendorTypes = [
    "Dealer",
    "Distributor",
    "Retailer",
    "Key Accounts",
    "PRO",
  ];
  const getCounter = async () => {
    const userId = userProfile?.employeeId;
    let allData = [];

    for (const type of vendorTypes) {
      const formData = new FormData();
      formData.append("vendor_type", type);
      formData.append("id", "");
      formData.append("userId", userId);

      try {
        const res = await utils.callAPI(
          "post",
          `/sales/getsalesFormbyid`,
          formData,
        );
        if (res && Array.isArray(res?.result)) {
          allData = [...allData, ...res.result];
        }
      } catch (err) {}
    }

    setCounter(allData); // Final merged result
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // if (props?.rowData?.status == "2") {
    setCurrentAction("edit");
    // }

    if (name === "counter") {
      const selectedCounter = counter.find((item) => item.id === value);
      if (selectedCounter) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
          city: selectedCounter.company_city,
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e, statusToSet) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      let finalStatus = statusToSet;
      if (props?.rowData?.status === "2") {
        if (currentAction === "edit") {
          finalStatus = "2";
        } else if (currentAction === "Advance Credited Amount") {
          finalStatus = "3";
        }
      } else if (props?.rowData?.status === "5") {
        finalStatus = "3";
      } else if (props?.rowData?.status === "6") {
        finalStatus = "7";
      }
      setCurrentStatus(finalStatus);
      setIsSubmit(true);
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  useEffect(() => {
    if (isSubmit) {
      const createFormData = async () => {
        const isBM = utils.hasPermission(
          primaryMenuRes,
          "Meeting",
          "meeting.BM",
        );

        const bodyFormData = new FormData();

        if (isEdit) {
          bodyFormData.append("id", props?.rowData?.id);
        }
        bodyFormData.append("emp_id", props?.rowData?.emp_id);
        bodyFormData.append(
          "meeting_date",
          moment(formData.meeting_date).format("YYYY-MM-DD"),
        );
        // bodyFormData.append("name", formData.meetingName);
        bodyFormData.append("subject", formData.subject);
        bodyFormData.append("counter", formData.counter);
        bodyFormData.append("city", formData.city);
        bodyFormData.append("budget", formData.budget);
        bodyFormData.append("counter_name", formData.counterName);
        bodyFormData.append("emp_notes", formData.notes);
        bodyFormData.append("reporting_id", "");
        bodyFormData.append("reporting_notes", "");
        bodyFormData.append(
          "brand_id",
          utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM")
            ? userProfile?.employeeId
            : "",
        );
        bodyFormData.append("brand_amt", brandAmt ? brandAmt : "");
        bodyFormData.append("brand_notes", brandNote ? brandNote : "");
        bodyFormData.append(
          "brand_advance_credit_amt",
          fileUpload ? fileUpload : "",
        );
        bodyFormData.append(
          "receive_notes",
          notReceiveNots ? notReceiveNots : "",
        );

        bodyFormData.append("updated_by", isBM ? "bm" : "emp");
        bodyFormData.append("current_action", currentAction);

        bodyFormData.append("status", currentStatus);
        bodyFormData.append("brand_final_notes", finalNote ? finalNote : "");
        bodyFormData.append(
          "brand_final_amt_attachment",
          finalAttach ? finalAttach : "",
        );
        bodyFormData.append("brand_final_amt", finalAmount ? finalAmount : "");
        bodyFormData.append("sales_id", "");
        bodyFormData.append(
          "emp_final_note",
          finalConfirmNote ? finalConfirmNote : "",
        );

        const categories = {
          meetingPhotos: "Meeting Photos",
          artisanData: "Artisan Data",
          meetingExpenses: "Meeting Expenses (Form)",
          expenseBills: "Expenses Bill",
        };

        const filesToBase64 = (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
              const base64 = reader.result;

              let newBase64 = base64;
              if (
                file.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ) {
                newBase64 = base64.replace(
                  "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
                  "data:application/xls;base64,",
                );
              } else if (
                file.type ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              ) {
                newBase64 = base64.replace(
                  "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,",
                  "data:application/msword;base64,",
                );
              }

              resolve(newBase64);
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
          });

        const finalData = await Promise.all(
          Object.keys(fileUploads).map(async (key) => {
            const meetingImages = await Promise.all(
              fileUploads[key].map(async (file) => ({
                file: await filesToBase64(file),
              })),
            );

            return {
              file_name: categories[key],
              meeting_image: meetingImages,
            };
          }),
        );
        bodyFormData.append("emp_meeting_files", JSON.stringify(finalData));
        let quotationFinalData = [];

        const activeQuotationFiles = quotation.filter((q) => !q.isDeleted);

        if (activeQuotationFiles.length > 0) {
          const base64Files = await Promise.all(
            activeQuotationFiles.map(async (item) => {
              const base64 = await convertToBase64(item.file);
              return {
                file: base64, // 🔑 SAME KEY backend expects
              };
            }),
          );

          quotationFinalData = [
            {
              file_name: "Quotation File",
              meeting_image: base64Files,
            },
          ];
        }
        bodyFormData.append(
          "emp_meeting_quatation_files",
          JSON.stringify(quotationFinalData),
        );

        utils
          .callAPI("post", `/meeting/save`, bodyFormData)
          .then((res) => {
            if (typeof res !== "undefined") {
              setIsSubmit(false);
              const propdata = {
                mode: "list",
              };
              props.onChange(propdata);
            }
            setIsSubmit(false);
          })
          .catch((err) => {
            setIsSubmit(false);
          });
      };

      createFormData();
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setIsEdit(true);
      setFormData({
        ...formData,
        meeting_date: props?.rowData?.meeting_date,
        meetingName: props?.rowData?.name,
        subject: props?.rowData?.subject,
        counter: props?.rowData?.counter,
        counterName: props?.rowData?.counter_name,
        city: props?.rowData?.city,
        budget: props?.rowData?.budget,
        notes: props?.rowData?.emp_notes,
      });
      setEditQuotation(props?.rowData?.quotation);
      setCurrentStatus(props?.rowData?.status);
      setFileUpload(props?.rowData?.brandattachPath);
      setBrandAmt(props?.rowData?.brand_amt);
      setBrandNote(props?.rowData?.brand_notes);
      setNotReceiveNotes(props?.rowData?.receive_notes || "-");
      setFinalAmount(props?.rowData?.brand_final_amt);
      setFinalAttach(props?.rowData?.brandFinalAmtPath);
      setFinalNote(props?.rowData?.brand_final_notes);
      setFinalConfirmNote(props?.rowData?.emp_final_note);
      if (props?.rowData?.document) {
        const categorizedFiles = props?.rowData?.document.reduce(
          (acc, doc) => {
            if (doc.file_name.includes("Meeting Photos")) {
              acc.meetingPhotos.push({
                id: doc.id,
                attachPath: doc.attachPath,
                filename: doc.meeting_image,
              });
            } else if (doc.file_name.includes("Artisan Data")) {
              acc.artisanData.push({
                id: doc.id,
                attachPath: doc.attachPath,
                filename: doc.meeting_image,
              });
            } else if (doc.file_name.includes("Meeting Expenses (Form)")) {
              acc.meetingExpenses.push({
                id: doc.id,
                attachPath: doc.attachPath,
                filename: doc.meeting_image,
              });
            } else if (doc.file_name.includes("Expenses Bill")) {
              acc.expenseBills.push({
                id: doc.id,
                attachPath: doc.attachPath,
                filename: doc.meeting_image,
              });
            }
            return acc;
          },
          {
            meetingPhotos: [],
            artisanData: [],
            meetingExpenses: [],
            expenseBills: [],
          },
        );

        setEditFileUploads(categorizedFiles);
      }
    } else {
      setIsEdit(false);
    }
  }, [props.rowData]);

  const refreshQueryList = () => {
    setQueryListRefreshTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    const isCreator =
      String(userProfile?.employeeId) === String(props?.rowData?.emp_id);
    const isPendingStatus = String(props?.rowData?.status) === "1";
    const status = String(props?.rowData?.status);
    const isBM = utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM");

    if (status === "8") {
      setisDisable(true); // Disable for all if status is 8
      setCurrentUserId(props?.rowData?.emp_id);
    } else if (isBM) {
      setisDisable(false); // BM can edit at any time (except status 8)
      setCurrentUserId(props?.rowData?.emp_id);
    } else if (isCreator && isPendingStatus) {
      setisquotation(false);

      setisDisable(false); // Creator can edit only during Pending status
      setCurrentUserId(props?.rowData?.emp_id);
    } else {
      setisDisable(true); // All others: disable
      setCurrentUserId(props?.rowData?.emp_id);
    }
  }, [userProfile, props?.rowData, primaryMenuRes]);

  const handleQuery = () => {
    setShowQueryModal(true);
  };

  const statusLabels = {
    1: { text: "Pending", variant: "warning" },
    2: { text: "BM Approved", variant: "success" },
    3: { text: "BM Amount Credited", variant: "primary" },
    4: { text: "Received", variant: "success" },
    5: { text: "Not Received", variant: "danger" },
    6: { text: "Documents Uploaded", variant: "primary" },
    7: { text: "Final Amount By BM", variant: "primary" },
    8: { text: "Confirm", variant: "success" },
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    setFileUpload(file);
    if (props?.rowData?.status == "3" || props?.rowData?.status == "5") {
      setCurrentAction("edit");
    } else {
      setCurrentAction("Advance Credited Amount");
    }
  };

  const isBM = utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM");
  const status = parseInt(props?.rowData?.status);

  const showBrandFields =
    (isBM && status >= 2) ||
    (!isBM && [3, 6, 8].includes(status)) ||
    status === 4 ||
    status === 5;

  const disableNotesField = isBM && (status === 4 || status === 5);
  const isSameUser = props?.rowData?.emp_id == userProfile?.employeeId;

  const handleRecive = () => {
    // if (currentAction === "Edit") {
    //   setCurrentStatus("3");
    // } else if (currentAction === "Advance Credited Amount") {
    setCurrentStatus("4");
    // }
    setError("");
    setIsSubmit(true);
  };

  const handleNoRecive = () => {
    setCurrentStatus("5");
    // if (!notReceiveNots.trim()) {
    //   setError("please enter notes.");
    //   return;
    // } else {
    //   setError("");
    // }
    setIsSubmit(true);
  };

  const handleMultiFileUpload = (status) => {
    setCurrentStatus(status);
    setIsSubmit(true);
  };

  const getFileIcon = (filePath) => {
    const ext = filePath?.split(".").pop()?.toLowerCase();

    switch (ext) {
      case "jpg":
      case "jpeg":
      case "png":
        return <Image size="20" color="#0d6efd" variant="Bold" />;
      case "pdf":
        return <DocumentText size="20" color="#dc3545" variant="Bold" />;
      case "xls":
      case "xlsx":
        return <DocumentCode size="20" color="#198754" variant="Bold" />;
      case "doc":
      case "docx":
        return <DocumentLike size="20" color="#0dcaf0" variant="Bold" />;
      default:
        return <Document size="20" color="#6c757d" variant="Outline" />;
    }
  };

  const [accordionOpen, setAccordionOpen] = useState(() => {
    // Open only if there are no documents uploaded yet
    const isFirstTime =
      Array.isArray(props?.rowData?.document) &&
      props?.rowData?.document.length === 0;
    console.log(props?.rowData?.document);
    return isFirstTime ? ["0"] : [];
  });

  const handleDownload = async (item,name) => {
    const fileName = "download";
    // const fileUrl = item.attachPath;

    try {
      const response = await fetch(item, {
        method: "GET",
        headers: {},
      });

      if (!response.ok) throw new Error("File fetch failed");

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = name;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.warn("CORS or Network error, opening in new tab instead:", error);

      window.open(item, "_blank");
    }
  };

  return (
    <div className="section-body">
      <RB.Card>
        <RB.Card.Header className="d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            {props?.rowData?.meeting_no} Meeting Details{" "}
            {statusLabels[props?.rowData?.status] && (
              <span
                className={`ms-1 text-${statusLabels[
                  props.rowData.status
                ].variant.toLowerCase()}`}
                style={{ fontSize: "0.9rem" }}
              >
                ({statusLabels[props.rowData.status].text})
              </span>
            )}
          </h4>

          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBackClick}>
              BACK
            </Link>
          </div>
        </RB.Card.Header>

        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mt-3">
                  <RB.FloatingLabel className="floating-label-fancy">
                    <DatePicker
                      selected={formData.meeting_date}
                      onChange={(date) => {
                        setFormData({ ...formData, meeting_date: date });
                        if (props?.rowData?.status == "2") {
                          setCurrentAction("edit");
                        }
                      }}
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      placeholderText="Select Meeting Date"
                      minDate={new Date()}
                      required
                      readOnly={isDisable}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="subject"
                    label="Type of Meeting"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Select
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                      name="subject"
                      className={`${isDisable ? "pointer-events-none" : ""}`}
                    >
                      <option value="">Type of Meeting</option>
                      {meeting?.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.subject_name}
                        </option>
                      ))}
                    </RB.Form.Select>
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  {props?.rowData?.emp_id !== userProfile?.employeeId ? (
                    <RB.FloatingLabel
                      controlId="counter"
                      readOnly
                      label="Counter"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        readOnly
                        type="text"
                        placeholder="Counter Name"
                        value={props?.rowData?.companyName}
                      />
                    </RB.FloatingLabel>
                  ) : (
                    <RB.FloatingLabel
                      controlId="counter"
                      readOnly={isDisable}
                      label="Select Counter"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Select
                        value={formData.counter}
                        onChange={handleInputChange}
                        readOnly={isDisable}
                        required
                        name="counter"
                      >
                        <option value="">Select Counter</option>
                        {Array.isArray(counter) &&
                          counter?.map((m) => (
                            <option key={m.id} value={m.id}>
                              {`${m.companyName} (${m.vendor_type})`}
                            </option>
                          ))}
                      </RB.Form.Select>
                    </RB.FloatingLabel>
                  )}
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="counterName"
                    label="Retail Counter/ Architect/ Contractor Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      readOnly={isDisable}
                      type="text"
                      placeholder="Counter Name"
                      name="counterName"
                      value={formData.counterName}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="city"
                    label="City"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      readOnly={isDisable}
                      placeholder="City"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="budget"
                    label="Budget"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      readOnly={isDisable}
                      placeholder="Budget"
                      name="budget"
                      value={formData.budget}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              <QuotationFile
                quotation={quotation}
                setQuotation={setQuotation}
                setEditQuotation={setEditQuotation}
                editQuotation={editQuotation}
                isquotation={isquotation}
                isEdit={Boolean(editQuotation?.length)}
              />
              <RB.Col md={12}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    controlId="notes"
                    label="Employee Notes"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      rows={3}
                      readOnly={isDisable}
                      placeholder="Employee Notes"
                      name="notes"
                      value={formData.notes}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
              {showBrandFields && (
                <>
                  <RB.Col md={6}>
                    <div className="mb-3">
                      <label className="form-label">
                        Advance Credited Amount
                      </label>
                      <div className="d-flex align-items-center">
                        {!isDisable && (
                          <RB.Form.Control
                            type="file"
                            name="quotation"
                            onChange={handleFileUpload}
                            className="me-2 flex-grow-1"
                          />
                        )}

                        {isEdit && props.rowData.brandattachPath && (
                          <div
                            className="d-flex flex-column align-items-center gap-2 ms-2"
                            style={{ width: "fit-content" }}
                          >
                            <a
                              href={props.rowData.brandattachPath}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-link p-0"
                              title="View Attachment"
                              style={{ maxWidth: "220px" }}
                            >
                              {(() => {
                                const fileUrl = props.rowData.brandattachPath;
                                const extension = fileUrl
                                  .split(".")
                                  .pop()
                                  .toLowerCase();
                                const isImage = ["jpg", "jpeg", "png"].includes(
                                  extension,
                                );

                                if (isImage) {
                                  return (
                                    <img
                                      src={fileUrl}
                                      alt="Attachment Preview"
                                      className="img-fluid rounded border"
                                      style={{
                                        maxHeight: "80px",
                                        objectFit: "cover",
                                      }}
                                    />
                                  );
                                } else {
                                  return (
                                    <div className="d-flex flex-column align-items-center text-secondary">
                                      <i
                                        className="material-icons-outlined"
                                        style={{ fontSize: "40px" }}
                                      >
                                        description
                                      </i>
                                      <small>{extension.toUpperCase()}</small>
                                    </div>
                                  );
                                }
                              })()}
                            </a>

                            <RB.Button
                              variant="primary"
                              size="sm"
                              className="btn-circle d-flex align-items-center justify-content-center"
                              title="Download"
                              onClick={() =>
                                handleDownload(props.rowData.brandattachPath,"attechment")
                              }
                              style={{ width: "32px", height: "32px" }}
                            >
                              <i
                                className="material-icons-outlined"
                                style={{ fontSize: "18px" }}
                              >
                                file_download
                              </i>
                            </RB.Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </RB.Col>

                  <RB.Col md={6}>
                    <div className="mt-2">
                      <RB.FloatingLabel
                        controlId="notes"
                        label="Amounts"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Amount"
                          // name="notes"
                          value={brandAmt}
                          readOnly={isDisable}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                              setBrandAmt(value);
                            }
                            if (
                              props?.rowData?.status == "3" ||
                              props?.rowData?.status == "5"
                            ) {
                              setCurrentAction("edit");
                            } else {
                              setCurrentAction("Advance Credited Amount");
                            }
                          }}
                          required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                  <RB.Col md={12}>
                    <div className="mb-3 mt-2">
                      <RB.FloatingLabel
                        controlId="notes"
                        label="Brand Manager Notes"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Brand Manager Notes"
                          name="notes"
                          readOnly={isDisable}
                          value={brandNote}
                          onChange={(e) => {
                            setBrandNote(e.target.value);
                            if (
                              props?.rowData?.status == "3" ||
                              props?.rowData?.status == "5"
                            ) {
                              setCurrentAction("edit");
                            } else {
                              setCurrentAction("Advance Credited Amount");
                            }
                          }}
                          // required
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                </>
              )}
              {props?.rowData?.status >= "3" && (
                <RB.Col md={12}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="notes"
                      label="Receive Notes"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Receive Notes"
                        value={notReceiveNots}
                        readOnly={
                          Number(userProfile?.employeeId) !==
                            Number(props?.rowData?.emp_id) ||
                          props?.rowData?.status === "4"
                        }
                        onChange={(e) => setNotReceiveNotes(e.target.value)}
                      />
                    </RB.FloatingLabel>
                    {error ? (
                      <>
                        <div className="text-danger">{error}</div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </RB.Col>
              )}

              {(Number(props?.rowData?.status) === 4 ||
                Number(props?.rowData?.status) > 5) &&
                (userProfile?.employeeId === props?.rowData?.emp_id ? (
                  // Meeting Creator can always see and upload
                  <RB.Accordion
                    activeKey={accordionOpen}
                    onSelect={(k) => setAccordionOpen(k)}
                  >
                    <RB.Accordion.Item eventKey="0">
                      <RB.Accordion.Header>
                        Upload Documents
                      </RB.Accordion.Header>
                      <RB.Accordion.Body>
                        <RB.Col md={12}>
                          <MultiFileUpload
                            fileUploads={fileUploads}
                            setFileUploads={setFileUploads}
                            EditfileUploads={EditfileUploads}
                            setEditFileUploads={setEditFileUploads}
                            isSameUser={true}
                            status={status}
                          />
                        </RB.Col>
                      </RB.Accordion.Body>
                    </RB.Accordion.Item>
                  </RB.Accordion>
                ) : (
                  // Other users can see only if documents exist
                  Object.values(EditfileUploads).some(
                    (arr) => arr.length > 0,
                  ) && (
                    <RB.Accordion defaultActiveKey={[]}>
                      <RB.Accordion.Item eventKey="0">
                        <RB.Accordion.Header>
                          View Documents
                        </RB.Accordion.Header>
                        <RB.Accordion.Body>
                          <RB.Col md={12}>
                            <MultiFileUpload
                              fileUploads={fileUploads}
                              setFileUploads={setFileUploads}
                              EditfileUploads={EditfileUploads}
                              setEditFileUploads={setEditFileUploads}
                              isSameUser={false}
                            />
                          </RB.Col>
                        </RB.Accordion.Body>
                      </RB.Accordion.Item>
                    </RB.Accordion>
                  )
                ))}

              {((status === 6 && isBM) ||
                status > 6 ||
                (status === 6 &&
                  (props?.rowData?.brand_final_amt ||
                    props?.rowData?.brand_final_notes ||
                    props?.rowData?.brandFinalAttachPath))) && (
                <>
                  {/* Final Amount File Upload */}
                  <RB.Col md={7}>
                    <div className="mb-3">
                      <label className="form-label">
                        Final Amount (Attachment)
                      </label>
                      <div className="d-flex align-items-center">
                        {isBM && status === 6 ? (
                          <RB.Form.Control
                            type="file"
                            name="finalAmountFile"
                            onChange={(e) => setFinalAttach(e.target.files[0])}
                            className="me-2 flex-grow-1"
                          />
                        ) : (
                          ""
                        )}

                        {isEdit && props.rowData?.brandFinalAmtPath && (
                          <div
                            className="d-flex flex-column align-items-center gap-2 ms-2"
                            style={{ width: "fit-content" }}
                          >
                            <a
                              href={props.rowData.brandFinalAmtPath}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-link p-0 ms-2"
                              title="View Final Attachment"
                              style={{ maxWidth: "120px" }}
                            >
                              {(() => {
                                const fileUrl = props.rowData.brandFinalAmtPath;
                                const extension = fileUrl
                                  .split(".")
                                  .pop()
                                  .toLowerCase();
                                const isImage = ["jpg", "jpeg", "png"].includes(
                                  extension,
                                );

                                if (isImage) {
                                  return (
                                    <img
                                      src={fileUrl}
                                      alt="Final Attachment Preview"
                                      className="img-fluid rounded"
                                      style={{ maxHeight: "80px" }}
                                    />
                                  );
                                } else {
                                  // return getFileIcon(fileUrl);
                                }
                              })()}
                            </a>

                            <RB.Button
                              variant="primary"
                              size="sm"
                              className="btn-circle d-flex align-items-center justify-content-center"
                              title="Download"
                              onClick={() =>
                                handleDownload(props.rowData.brandFinalAmtPath,'final_attechment')
                              }
                              style={{ width: "32px", height: "32px" }}
                            >
                              <i
                                className="material-icons-outlined"
                                style={{ fontSize: "18px" }}
                              >
                                file_download
                              </i>
                            </RB.Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </RB.Col>

                  {/* Final Amount Textbox */}
                  <RB.Col md={5}>
                    <div className="mt-2">
                      <RB.FloatingLabel
                        controlId="finalAmount"
                        label="Final Amount"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          type="text"
                          placeholder="Final Amount"
                          value={
                            finalAmount || props?.rowData?.brand_final_amt || ""
                          }
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value))
                              setFinalAmount(value);
                          }}
                          readOnly={!(isBM && status === 6)}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>

                  {/* Final Notes */}
                  <RB.Col md={12}>
                    <div className="mb-3">
                      <RB.FloatingLabel
                        controlId="finalNote"
                        label="Brand Manager Final Notes"
                        className="floating-label-fancy"
                      >
                        <RB.Form.Control
                          as="textarea"
                          placeholder="Brand Manager Final Notes"
                          rows={3}
                          value={
                            finalNote || props?.rowData?.brand_final_notes || ""
                          }
                          onChange={(e) => setFinalNote(e.target.value)}
                          readOnly={!(isBM && status === 6)}
                        />
                      </RB.FloatingLabel>
                    </div>
                  </RB.Col>
                </>
              )}
              {status >= 7 && ((status === 7 && isSameUser) || status >= 8) && (
                <RB.Col md={12}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      controlId="finalConfirmNote"
                      label="Final Confirmation Note"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        as="textarea"
                        placeholder="Final Confirmation Note"
                        rows={3}
                        value={
                          status === 7 && isSameUser
                            ? finalConfirmNote
                            : props?.rowData?.emp_final_note || "-"
                        }
                        onChange={(e) => setFinalConfirmNote(e.target.value)}
                        readOnly={status !== 7 || !isSameUser}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              )}
            </RB.Row>
            {(parseInt(props?.rowData?.status) === 4 ||
              (parseInt(props?.rowData?.status) > 5 &&
                parseInt(props?.rowData?.status) < 7)) &&
              userProfile?.employeeId === props?.rowData?.emp_id && (
                <RB.Row className="justify-content-end mt-1">
                  <RB.Col className="col-auto">
                    <RB.Button
                      className="me-2"
                      variant="primary"
                      type="button"
                      onClick={(e) => handleMultiFileUpload("6")}
                    >
                      Upload
                    </RB.Button>
                  </RB.Col>
                </RB.Row>
              )}

            {(utils.hasPermission(primaryMenuRes, "Meeting", "meeting.BM") ||
              (String(userProfile?.employeeId) ===
                String(props?.rowData?.emp_id) &&
                String(props?.rowData?.status) === "1")) && (
              <RB.Row className="justify-content-end mt-3">
                <RB.Col className="col-auto">
                  {props?.rowData?.status !== "8" && (
                    <RB.Button
                      className="me-2"
                      variant="primary"
                      type="button"
                      onClick={(e) => handleSubmit(e, props?.rowData?.status)}
                    >
                      Updates
                    </RB.Button>
                  )}

                  {utils.hasPermission(
                    primaryMenuRes,
                    "Meeting",
                    "meeting.BM",
                  ) &&
                    props.rowData?.status === "1" && (
                      <RB.Button
                        variant="success"
                        type="button"
                        onClick={(e) => handleSubmit(e, "2")}
                      >
                        Approve
                      </RB.Button>
                    )}
                </RB.Col>
              </RB.Row>
            )}

            {userProfile?.employeeId === props?.rowData?.emp_id &&
              props?.rowData?.status === "3" && (
                <RB.Row className="justify-content-end mt-3">
                  <RB.Col className="col-auto">
                    <RB.Button
                      className="me-2"
                      variant="success"
                      type="button"
                      onClick={(e) => handleRecive()}
                    >
                      Received
                    </RB.Button>
                    <RB.Button
                      variant="danger"
                      type="button"
                      onClick={(e) => handleNoRecive()}
                    >
                      Not Received
                    </RB.Button>
                  </RB.Col>
                </RB.Row>
              )}

            {/* Confirm Button - Only for Creator at status 7 */}
            {status === 7 && isSameUser && (
              <RB.Row className="justify-content-end mt-2">
                <RB.Col className="col-auto">
                  <RB.Button
                    variant="success"
                    type="button"
                    // readOnly={!finalConfirmNote.trim()}
                    onClick={() => {
                      setCurrentStatus("8");
                      setIsSubmit(true);
                    }}
                  >
                    Confirm
                  </RB.Button>
                </RB.Col>
              </RB.Row>
            )}
          </RB.Form>
          <RB.Card className="mt-2">
            <RB.CardBody>
              <RB.Row className="justify-content-end">
                <RB.Col className="col-auto">
                  <RB.Button variant="warning" onClick={handleQuery}>
                    FeedBack
                  </RB.Button>
                </RB.Col>
              </RB.Row>
              <QueryList
                meetingId={props?.rowData?.id}
                empId={currentUserId}
                trigger={queryListRefreshTrigger}
              />
            </RB.CardBody>
          </RB.Card>
        </RB.Card.Body>
      </RB.Card>
      <QueryModal
        show={showQueryModal}
        onHide={() => setShowQueryModal(false)}
        meetingId={props?.rowData?.id}
        empId={currentUserId}
        onQuerySubmitted={refreshQueryList}
      />
    </div>
  );
}

export default View;
